import React from 'react';
import { Joyride, STATUS } from 'react-joyride';

const STEPS = [
  {
    target: '#tour-dashboard',
    title: 'Dashboard',
    content: 'Your home base — see client progress, recent sessions, and quick stats at a glance.',
    disableBeacon: true,
  },
  {
    target: '#tour-clients',
    title: 'Clients',
    content: 'Manage all your coaching clients. Each client has a full profile with sessions, goals, breakthroughs, and an AI-generated avatar.',
    disableBeacon: true,
  },
  {
    target: '#tour-new-session',
    title: 'New Session',
    content: 'Start here after a session. Paste a transcript (or record live) and Claude will generate a full AI summary, goals, and breakthrough quotes.',
    disableBeacon: true,
  },
  {
    target: '#tour-schedule',
    title: 'Schedule',
    content: 'Plan upcoming sessions for individual clients or groups.',
    disableBeacon: true,
  },
  {
    target: '#tour-settings',
    title: 'Settings',
    content: 'Update your practice profile, switch your coaching modality, add your Anthropic API key, and configure notifications.',
    disableBeacon: true,
  },
];

export default function AppTour({ onFinish }) {
  const handleCallback = ({ status }) => {
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      onFinish();
    }
  };

  return (
    <Joyride
      steps={STEPS}
      run={true}
      continuous
      showSkipButton
      showProgress
      disableScrolling
      spotlightPadding={8}
      callback={handleCallback}
      styles={{
        options: {
          primaryColor: '#5C7A6B',
          backgroundColor: '#fff',
          textColor: '#1C2B26',
          arrowColor: '#fff',
          overlayColor: 'rgba(26, 46, 40, 0.75)',
          zIndex: 10000,
        },
        spotlight: {
          borderRadius: '10px',
          border: '2px solid #C4956A',
          boxShadow: '0 0 0 4px rgba(196, 149, 106, 0.35), 0 0 24px 8px rgba(196, 149, 106, 0.45)',
          backgroundColor: 'rgba(196, 149, 106, 0.08)',
        },
        beaconInner: {
          backgroundColor: '#C4956A',
        },
        beaconOuter: {
          backgroundColor: 'rgba(196, 149, 106, 0.3)',
          borderColor: '#C4956A',
        },
        tooltip: {
          borderRadius: '12px',
          padding: '20px 24px',
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '14px',
        },
        tooltipTitle: {
          fontFamily: "'Lora', serif",
          fontSize: '16px',
          fontWeight: '600',
          marginBottom: '8px',
        },
        buttonNext: {
          borderRadius: '6px',
          padding: '8px 18px',
          fontSize: '13px',
          fontWeight: '600',
          fontFamily: "'DM Sans', sans-serif",
        },
        buttonBack: {
          fontSize: '13px',
          fontFamily: "'DM Sans', sans-serif",
          color: '#7A8C86',
        },
        buttonSkip: {
          fontSize: '13px',
          fontFamily: "'DM Sans', sans-serif",
          color: '#7A8C86',
        },
      }}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Done',
        next: 'Next',
        skip: 'Skip tour',
      }}
    />
  );
}
